import { render, staticRenderFns } from "./LookUpDesk.vue?vue&type=template&id=6fdcbfbd"
import script from "./LookUpDesk.vue?vue&type=script&lang=js"
export * from "./LookUpDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports